import * as yup from 'yup';
import i18n from 'i18n';

export const resetPasswordSchema = yup.object().shape({
  password: yup.string().required(() => i18n.t('website:auth.resetPassword.validation.passwordRequired')),
  confirmPassword: yup
    .string()
    .required(() => i18n.t('website:auth.resetPassword.validation.confirmPasswordRequired'))
    .oneOf([yup.ref('password')], () => i18n.t('website:auth.resetPassword.validation.passwordsMismatch')),
});
